import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["CannyPricingCalculator"] */ "/opt/buildhome/repo/src/app/(marketing)/tools/canny-pricing-calculator/calculator.tsx");
